import { cbSemanticCssVars, typographyCss, colors } from '@creditornot/cb-ingredients';
import { pxToRem } from '@creditornot/cb-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
`;

const Title = styled.div`
  ${typographyCss.Title1};
  font-weight: 700;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${pxToRem(8)} ${pxToRem(16)};
`;

const Root = styled.div`
  background-color: ${colors.wolt8};
  border: 1px solid;
  border-color: ${cbSemanticCssVars.borderPrimary};
  border-radius: 8px;
`;

export const ExistingFreeTrialPlaceholder = () => (
  <Root data-test-id="free-trial-existing-placeholder">
    <Header>
      <TitleContainer>
        <img src={`${process.env.CDN_URL}/ads/free-trial-coin.png`} alt="" />
        <Title>
          <FormattedMessage id="campaigns.ads.free-trials.free-trial-applied" />
        </Title>
      </TitleContainer>
    </Header>
  </Root>
);
